var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarPreferences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5H6.07",
    stroke: "#B0B7C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3234 3.73223C11.2997 4.70854 11.2997 6.29145 10.3234 7.26776C9.34712 8.24407 7.76421 8.24407 6.7879 7.26776C5.81159 6.29145 5.81159 4.70854 6.7879 3.73223C7.76421 2.75592 9.34712 2.75592 10.3234 3.73223",
    stroke: "#B0B7C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0596 5.5H20.9996",
    stroke: "#B0B7C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3234 3.73223C11.2997 4.70854 11.2997 6.29145 10.3234 7.26776C9.34712 8.24407 7.76421 8.24407 6.7879 7.26776C5.81159 6.29145 5.81159 4.70854 6.7879 3.73223C7.76421 2.75592 9.34712 2.75592 10.3234 3.73223",
    stroke: "#B0B7C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0004 12H17.9404",
    stroke: "#B0B7C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.94 12H3",
    stroke: "#B0B7C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2121 10.2322C18.1884 11.2085 18.1884 12.7915 17.2121 13.7678C16.2358 14.7441 14.6529 14.7441 13.6766 13.7678C12.7003 12.7915 12.7003 11.2085 13.6766 10.2322C14.6529 9.25592 16.2358 9.25592 17.2121 10.2322",
    stroke: "#B0B7C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0596 18.5H20.9996",
    stroke: "#B0B7C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3 18.5H6.06",
    stroke: "#B0B7C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3234 16.7322C11.2997 17.7085 11.2997 19.2915 10.3234 20.2678C9.34712 21.2441 7.76421 21.2441 6.7879 20.2678C5.81159 19.2915 5.81159 17.7085 6.7879 16.7322C7.76421 15.7559 9.34712 15.7559 10.3234 16.7322",
    stroke: "#B0B7C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarPreferences);
export default __webpack_public_path__ + "static/media/side-bar-preferences.fcfadeb4acbc7c4bca63ab276f83f3ed.svg";
export { ForwardRef as ReactComponent };